<template>
  <div class="cargoStatusPageContainer">
    <div class="cargoStatusHeader" style="margin-bottom: 15px">Статус груза</div>
    <el-form @submit.prevent="submitForm(formRef)" class="formWrapper" :model="formData" :rules="formRules" ref="formRef">
      <el-form-item class="numberRaspiskaInput" prop="cargoNumber">
        <el-input v-mask="CARGO_NUM_MASK" placeholder="Укажите номер расписки" v-model="formData.cargoNumber"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button style="width: 90px" type="primary" @click="submitForm(formRef)" :disabled="isLoading">{{ isLoading ? 'Загрузка...' : 'Поиск' }}</el-button>
      </el-form-item>
    </el-form>
    <CargoStatusStepper :active-step="activeStep" :stepperStatusTexts="stepperStatusTexts" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useYandexMetrika } from 'yandex-metrika-vue3';
import { CargoStatusStepper } from './features';
const formData = ref({
  cargoNumber: '',
});

const yandexMetrika = useYandexMetrika();

const activeStep = ref(-1);

const formRef = ref();

const stepperStatusTexts = ['Заявка в работе', 'Принято на склад', 'В пути', 'Принят в город назначения', 'Доставка по городу', 'Выдано'];

const formRules = ref({
  cargoNumber: [
    { required: true, message: 'Введите номер', trigger: 'blur' },
    { pattern: /^\d{2}-\d{5}$/, message: 'Формат номера: 99-99999', trigger: 'blur' },
  ],
});

const CARGO_NUM_MASK = '##-#####';

const isLoading = ref(false);

function getStep(status) {
  switch (status) {
    case 'active':
      return 0;
    case 'gruz':
      return 1;
    case 'mtp':
      return 2;
    case 'arrived':
      return 3;
    case 'delivery':
      return 4;
    case 'given':
      return 5;
    default:
      return -1;
  }
}

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      try {
        isLoading.value = true;
        yandexMetrika.reachGoal('cargoStatus');
        const response = await fetch(`https://b2b.otr-it.ru/api/public/orderstatus?number=${formData.value.cargoNumber}`);
        const data = await response.json();
        const step = getStep(data.status);
        stepperStatusTexts[step] = data.statusTitle;
        activeStep.value = step;
      } catch (e) {
        console.log(e);
        activeStep.value = -1;
      } finally {
        isLoading.value = false;
      }
    } else {
      console.log('error submit!', fields);
    }
  });
};
</script>
<style lang="scss">
.cargoStatusPageContainer {
  text-align: start;
  max-width: 1498px;
  margin: 0 auto;
  background-color: #f0f0f3;
  box-shadow: -11px 11px 22px rgba(204, 204, 207, 0.2), 11px -11px 22px rgba(204, 204, 207, 0.2), -11px -11px 22px rgba(255, 255, 255, 0.9), 11px 11px 28px rgba(204, 204, 207, 0.9),
    inset 1px 1px 2px rgba(255, 255, 255, 0.3), inset -1px -1px 2px rgba(204, 204, 207, 0.5);
  border-radius: 16px;
  padding: 40px 40px 20px 40px;

  .cargoStatusHeader {
    font-size: 28px;
    margin-bottom: 25px;
  }

  .formWrapper {
    display: flex;
    align-items: center;
    gap: 30px;
    margin-bottom: 20px;
    .numberRaspiskaInput {
      flex: 1;
    }
  }
}

@media (max-width: 750px) {
  .cargoStatusPageContainer {
    padding: 15px 15px 10px 15px;
  }
}
</style>
